import { createEntityCommentsBlock } from "../entity/createEntityCommentsBlock.jsx";

const ObjektEntityCommentsBlock = createEntityCommentsBlock({
  title: "💬 Kommentare",
  compact: true,
  draftKeyPrefix: "wt_draft_comment_objekt",
  getApiPaths: (objektId) => ({
    list: `/objekte/${objektId}/kommentare`,
    create: `/objekte/${objektId}/kommentar`,
    update: (id) => `/objekte/${objektId}/kommentar/${id}`,
    remove: (id) => `/objekte/${objektId}/kommentar/${id}`,
  }),
  buildCreatePayload: (text) => ({ text }),
  buildUpdatePayload: (text) => ({ text }),
});

export default function ObjektBlockKommentare({ objektId }) {
  return <ObjektEntityCommentsBlock entityId={objektId} />;
}
